import { useField } from 'formik'
import moment from 'moment'
import { memo, useRef } from 'react'
import useFocusOnError from '@/hooks/use-focus-on-error'
import Base from './base'
import Error from '../error'

const FieldDatetimePicker = ({
  name,
  onChange,
  format = 'YYYY-MM-DD hh:mm:ss A',
  displayFormat,
  ...rest
}) => {
  const [field, meta, helpers] = useField(name)
  const fieldRef = useRef()
  useFocusOnError({ fieldRef, name })
  const hasError = !!meta.error && meta.touched
  const value = field.value ? moment(field.value) : null
  return (
    <>
      <Base
        ref={fieldRef}
        {...field}
        {...rest}
        hasError={hasError}
        value={value}
        format={displayFormat}
        onChange={date => {
          const formatDate = () => (date.format ? date.format(format) : date)
          const value = date ? formatDate() : ''
          helpers.setTouched(true, false)
          if (onChange) {
            onChange(value)
          } else {
            helpers.setValue(date ? date : '')
          }
        }}
      />
      <Error name={name} />
    </>
  )
}

export default memo(FieldDatetimePicker)
